<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    世界之窗站<br>
站点介绍<br>
世界之窗站是1号线与2号线的换乘车站，车站位于著名景区世界之窗中轴线以西，深南大道下，车站主体平行于深南大道，大致呈东西走向。在站址周围有沙河世纪假日广场、益田假日广场、威斯汀酒店、威尼斯酒店及著名旅游景点世界之窗、欢乐谷。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:01	23:38	1号线	2分钟	4分40秒<br>
机场东	06:00	23:30	1号线	2分钟	4分40秒<br>
赤湾	06:35	00:15	2号线	2分35秒	5分45秒<br>
莲塘	06:00	23:26	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:28	23:37	1号线	3分45秒	5分45秒<br>
机场东	06:20	23:30	1号线	3分45秒	5分45秒<br>
赤湾	06:39	00:14	2号线	4分钟	5分钟<br>
莲塘	06:03	23:26	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:28	00:37	1号线	3分45秒	5分45秒<br>
机场东	06:20	00:30	1号线	3分45秒	5分45秒<br>
赤湾	06:39	01:04	2号线	4分钟	5分钟<br>
莲塘	06:03	00:26	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道北侧、南山、宝安方向、侨城西街、世界之窗站总站、欢乐谷、益田假日广场、城市客栈欢乐谷店、益田威斯汀酒店、世界之窗①<br><br>
B出入口:<br>
深南大道北侧、益田假日广场、沙河大厦、沙河小学<br><br>
C1出入口:<br>
深南大道北侧、 南山、宝安方向、金河路、趣WAY商业街、沙河小学、白石洲、 深圳沙河医院、世界之窗地铁公交接驳站、世界之窗②<br><br>
C2出入口:<br>
益田假日广场<br><br>
C3出入口:<br>
益田假日广场<br><br>
H1出入口:<br>
深南大道南侧、罗湖、福田方向、世界之窗-狂欢节广场、阿尔卑斯冰雪世界滑冰场、世界之窗停车场、白石洲、趣WAY商业街世界之窗地铁公交接驳站、世界之窗①、世界之窗②<br><br>
H2出入口:<br>
世界之窗停车场、深南大道南侧<br><br>
I出入口:<br>
深南大道南侧、狂欢节广场、世界之窗停车场<br><br>
J出入口:<br>
深南大道南、世界之窗（金字塔）<br><br>
K出入口:<br>
世界之窗广场、世界之窗停车场<br><br>
公交换乘信息<br><br>

公交站名： A出入口丨世界之窗①<br>
113、204、223、M132、M191、M486、M487、90、N4、M312、联通区间线、21、26、70、101、42<br><br>

公交站名： C出入口丨世界之窗②<br>
M165、M194、M222、M413、323、324、369、M448<br><br>

公交站名： C、H出入口丨公交接驳站<br>
392、66、M425、43、M535、M435、36、395<br><br>

公交站名： H出入口丨世界之窗①<br>
113、223、M132、21、26、70、204、90、101、M486、M487、N04、联通区间线、42、M312、深圳观光巴士（蓝线）、深圳观光巴士（橙线）<br><br>

公交站名： H出入口丨世界之窗②<br>
323、324、369、M165、M191、M194、M222、M413、M448<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>





